import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZER, ModuleWithProviders, NgModule, Optional, SkipSelf } from '@angular/core';
import { BrewersUnitOfWork } from 'app/core/data/client-unit-of-work';
import { EntitiesService } from 'app/core/data/entities.service';
import { EntityManagerProvider } from 'app/core/data/entity-manager-provider';
import { PrepareGuard } from 'app/core/prepare.guard';
import { AppInformationService } from './app-information.service';
import { AuthGuard } from './auth.guard';
import { AuthService } from './auth.service';
import { UtilityService } from './data/utility.service';
import { ErrorInterceptor } from './error-interceptor';
import { JwtInterceptor } from './jwt.interceptor';
import { MessageService } from './message.service';
import { SessionInformationService } from './session-information.service';

export {
    AppInformationService as AppInformationService1,
    PrepareGuard,
    EntitiesService,
    AuthGuard,
    AuthService,
    AppInformationService,
    SessionInformationService,
    BrewersUnitOfWork,
    MessageService,
    UtilityService,
};

export function appInitializer(authenticationService: AuthService) {
    return () =>
        new Promise(resolve => {
            // attempt to refresh token on app start up to auto authenticate
            authenticationService.refreshToken().subscribe().add(resolve as any);
        });
}

@NgModule({ declarations: [], imports: [CommonModule], providers: [
        { provide: APP_INITIALIZER, useFactory: appInitializer, multi: true, deps: [AuthService] },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        // { provide: ErrorHandler, useClass: ToastErrorHandler },
        AppInformationService,
        EntitiesService,
        PrepareGuard,
        AuthGuard,
        AuthService,
        SessionInformationService,
        AppInformationService,
        BrewersUnitOfWork,
        EntityManagerProvider,
        UtilityService,
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class CoreModule {
    static forRoot(): ModuleWithProviders<CoreModule> {
        return {
            ngModule: CoreModule,
            providers: [AppInformationService, AuthService, SessionInformationService, AppInformationService, BrewersUnitOfWork, EntityManagerProvider],
        };
    }

    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        if (parentModule) {
            throw new Error('CoreModule is already loaded. Import it in the AppModule only');
        }
    }
}
